import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { InstructionsComponent } from '../instructions/instructions.component';
import { FileCaptureService } from '../service/file-capture.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  @Input()
  isDashboard: boolean = false;

  isInstructionsEnabled: boolean = false;
  instructionText: string = '';

  private readonly instructionEnabledKey = 'fc_instruction_enabled';
  private readonly instructionTextKey = 'fc_instruction_text';
  private readonly knownRoutes = new Set([
    'reference',
    'file-upload',
    'review-files',
    'confirmation',
    'email-auth'
  ]);

  constructor(private fcservice: FileCaptureService, private router: Router, private modalService: NgbModal) { }

  ngOnInit(): void {
    this.loadInstructionsFromCache();
    if (!this.instructionText) {
      const securityCode = this.resolveSecurityCode();
      if (securityCode) {
        this.loadInstructionsFromApi(securityCode);
      }
    }
  }

  showInstructions(): void {
    if (!this.instructionText) {
      return;
    }

    const modalRef = this.modalService.open(InstructionsComponent, { size: 'lg', ariaLabelledBy: 'Instructions' });
    modalRef.componentInstance.name = this.instructionText;
  }

  private loadInstructionsFromCache(): void {
    this.isInstructionsEnabled = window.localStorage.getItem(this.instructionEnabledKey) === 'true';
    this.instructionText = window.localStorage.getItem(this.instructionTextKey) || '';
  }

  private resolveSecurityCode(): string {
    const storedCode = window.localStorage.getItem('securityCode') || '';
    if (storedCode) {
      return storedCode;
    }

    const pathSegment = this.router.url.split('?')[0].split('/').filter(Boolean)[0] || '';
    if (!pathSegment) {
      return '';
    }

    if (this.knownRoutes.has(pathSegment.toLowerCase())) {
      return '';
    }

    window.localStorage.setItem('securityCode', pathSegment);
    return pathSegment;
  }

  private loadInstructionsFromApi(securityCode: string): void {
    this.fcservice.getFileCaptureConfig(securityCode).subscribe({
      next: (config) => {
        const instructionEnabled = !!(config && config.InstructionEnabled);
        const instruction = (config?.Instruction || config?.instruction || '').toString();
        const formattedInstruction = instruction ? instruction.replace('<img ', '<img title="Header" ') : '';

        this.isInstructionsEnabled = instructionEnabled;
        this.instructionText = formattedInstruction;

        window.localStorage.setItem(this.instructionEnabledKey, String(instructionEnabled));
        window.localStorage.setItem(this.instructionTextKey, formattedInstruction);
      },
      error: () => {
        this.isInstructionsEnabled = false;
        this.instructionText = '';
      }
    });
  }

}
